import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { auth as authStore } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => authStore.getUser());

  useEffect(() => {
    const onChange = () => setUser(authStore.getUser());
    window.addEventListener('wms:auth-changed', onChange);
    return () => window.removeEventListener('wms:auth-changed', onChange);
  }, []);

  const login = useCallback(({ accessToken, refreshToken, user }) => {
    authStore.set({ accessToken, refreshToken, user });
  }, []);

  const logout = useCallback(() => {
    authStore.clear();
  }, []);

  const value = { user, login, logout, isAuthenticated: !!user };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
}
